import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlarmsTableComponent } from './alarms-table/alarms-table.component';
import { AlarmsSummaryComponent } from './alarms-summary/alarms-summary.component';
import {LayoutModule} from '../../components/layout/layout.module';
import {SearchModule} from '../../components/search/search.module';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {MaterialModule} from '../../material.module';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';
import { AlarmsSearchComponent } from './alarms-search/alarms-search.component';
import {DialogModule} from '../../components/dialog/dialog.module';
import {FormsModule} from '@angular/forms';
import {InfraModule} from 'ac-infra';
import {AlarmPipesModule} from '../pipes/alarm-pipes.module';
import {FlexModule} from '@angular/flex-layout';



@NgModule({
  declarations: [AlarmsTableComponent, AlarmsSummaryComponent, AlarmsSearchComponent],
  exports: [
    AlarmsTableComponent
  ],
  imports: [
    CommonModule,
    LayoutModule,
    SearchModule,
    ActionBarModule,
    MaterialModule,
    ArmTableModule,
    DialogModule,
    FormsModule,
    InfraModule,
    AlarmPipesModule,
    FlexModule
  ]
})
export class AlarmsComponentsModule { }
